(ns frontend.ui.page.lp-report-editor.common.view
  (:require
   [common.localization :as loc]
   [common.schema.entities.lp-portal.lp-report-holding :as lp-report-holding]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.icon.view :refer [icon]]
   [frontend.ui.component.tab-layout.view :as tab-layout]
   [frontend.ui.page.lp-portal.report.view :as report-view]
   [frontend.ui.page.lp-report-editor.common.event :as event]
   [frontend.ui.page.lp-report-editor.common.style :as style]
   [frontend.ui.page.lp-report-editor.common.sub :as sub]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.style :as editor-style]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn continue-button
  []
  [button/secondary-hollow
   {:on-click #(rf/dispatch [::editor-event/close-editor])}
   (loc/tr :continue-later)])

(defn next-button
  [_dispatch-on-click]
  #_[button/primary-solid
     {:on-click #(rf/dispatch dispatch-on-click)}
     (loc/tr :next)])

(defn pdf-button
  [{:keys [on-click]}]
  [button/primary-solid
   {:on-click on-click}
   (loc/tr :save-as-pdf)])

(defn preview-pdf-button
  [{:keys [on-click]}]
  [button/primary-solid
   {:on-click on-click}
   (loc/tr :preview-pdf)])

(defn preview-holding-pdf-page-button
  [{:keys [on-click]}]
  [button/primary-solid
   {:on-click on-click}
   (loc/tr :preview-holding-page-pdf)])

(defn burn-pdf-button
  [{:keys [on-click]}]
  [button/primary-solid
   {:on-click on-click}
   (loc/tr :burn-pdfs)])

(defn close-button
  [{:keys [on-click]}]
  [button/secondary-hollow
   {:on-click on-click}
   (loc/tr :close)])

(defn footer
  [{:keys [left-content right-content]}]
  [:div
   {:class (<class style/footer-container)}
   [grid/container {}
    [grid/row {}
     [grid/column {:small 7}
      [:div
       {:class (<class style/footer-left)}
       left-content]]
     [grid/column {:small 5}
      [:div
       {:class "flex gap-3 justify-end"}
       right-content]]
    ]]])

(defn icon-step
  []
  [:div
   {:class (<class style/icon-step)}
   [icon :circle]])

(defn icon-step-done
  []
  [:div
   {:class (<class style/icon-step-done)}
   [icon :check-circle]])

(defn full-report
  [report-id]
  (let [report @(rf/subscribe [::editor-sub/report report-id])
        fund-template (:lp-report/template-type report)
        fund-report-ui-data @(rf/subscribe [::editor-sub/fund-report-ui-data (:db/id report)])
        holdings @(rf/subscribe [::editor-sub/lp-report-holdings])
        shown-holding-reports
        (->> (:lp-report/holdings report)
             (map (fn [holding-id]
                    (get holdings holding-id)))
             (remove (fn [holding-report]
                       (let [holding-template (:lp-report-holding/template-type holding-report)]
                         (or (nil? holding-template)
                             (= :lp-report-holding-template/no-reporting holding-template)))))
             (sort lp-report-holding/compare-holdings))]
    [:div
     {:class (<class editor-style/page-body)}
     [:div
      {:class (<class style/sidebar-nav)}
      (->> shown-holding-reports
           (sort lp-report-holding/compare-holdings)
           (map (fn [holding-report]
                  ^{:key (str "holding-report-link-" (:db/id holding-report))}
                  [:a
                   {:class (<class style/sidebar-nav-link)
                    :href  (str "#holding-report-" (:db/id holding-report))}
                   (:lp-report-holding/name holding-report)]))
           (doall))]
     [:div
      {:class (<class style/spacing-top)}
      [grid/container {}
       [grid/row {}
        [grid/column {:span 12}
         (when (and fund-report-ui-data
                    fund-template)
           [report-view/fund-report-content
            {:fund-template-type (:lp-report/template-type report)
             :report       report
             :fund-ui-data fund-report-ui-data}])]]]]
     (->> shown-holding-reports
          (map (fn [holding-report]
                 (let [template-type (:lp-report-holding/template-type holding-report)
                       ui-data @(rf/subscribe [::editor-sub/holding-report-ui-data
                                               (:db/id holding-report)])]
                   ^{:key (str "report-review-holding-report-" (:db/id holding-report))}
                   [grid/container {}
                    [grid/row {}
                     [grid/column {:span 2}]
                     [grid/column {:span 12}
                      [report-view/holding-report-content
                       {:holding-template-type template-type
                        :holding-ui-data       ui-data
                        :fund-ui-data          fund-report-ui-data}]]]
                   ])))
          (doall))
     [:div
      {:class (<class style/spacing-top)}
      [grid/container {}
       [grid/row {}
        [grid/column {:large 12}
         (when (and fund-report-ui-data
                    fund-template)
           [report-view/last-content
            {:fund-template-type (:lp-report/template-type report)
             :report       report
             :fund-ui-data fund-report-ui-data}])]]]]]))

(defn report-viewer
  [report-tab-path step-footer]
  (let [lp-report @(rf/subscribe [::editor-sub/lp-report])
        feeder-access? @(rf/subscribe [::editor-sub/feeder-access?])
        main-report-access? @(rf/subscribe [::editor-sub/master-report-access?])
        feeder-id (:db/id (first @(rf/subscribe [::editor-sub/feeder-reports])))
        selected-report-tab @(rf/subscribe [::sub/report-tab report-tab-path])
        selected-report-id (cond
                             (and feeder-access?
                                  (not main-report-access?))
                             feeder-id
                             (and main-report-access?
                                  (= :master-report selected-report-tab))
                             (:db/id lp-report)
                             (and feeder-access?
                                  (= :feeder-report selected-report-tab))
                             feeder-id
                             main-report-access?
                             (:db/id lp-report)
                             feeder-access?
                             feeder-id
                             :else
                             nil)
        selected-report @(rf/subscribe [::editor-sub/report selected-report-id])]
    [:<>
     [:<>
      (when (and feeder-id main-report-access?)
        [tab-layout/tab-layout
         {:selected      @(rf/subscribe [::sub/report-tab report-tab-path])
          :on-tab-change (fn [k]
                           (rf/dispatch [::event/change-tab report-tab-path k]))}
         {:master-report {:title (loc/tr :master-report)}
          :feeder-report {:title (loc/tr :feeder-report)}}])
      [full-report selected-report-id]]
     [step-footer selected-report (= selected-report-id feeder-id)]]))
